import moment from 'moment';
import Dexie from 'dexie';

export const db = new Dexie('myfleet');

db.version(1).stores({
    reverseAddresses: '++id, created_at, latitude, longitude'
});

export const NAMESPACE_PREFIX = 'io.myair.myfleet';

const buildNamespace = (key, extraKey = undefined) => {
    return `${NAMESPACE_PREFIX}.${key}${extraKey !== undefined ? `.${extraKey}` : ''}`;
};

export const getItem = (keyName) => window.localStorage.getItem(buildNamespace(keyName));

export const setItem = (keyName, keyValue) => window.localStorage.setItem(buildNamespace(keyName), keyValue);

export const removeItem = (keyName) => window.localStorage.removeItem(buildNamespace(keyName));

export const clear = () => window.localStorage.clear();

const REVERSE_ADDRESSES_LIFETIME = 30 * 86400;

export const pruneReverseAddresses = async () => {
    try {
        const deleteCount = await db.reverseAddresses
            .where('created_at').below(moment().subtract(REVERSE_ADDRESSES_LIFETIME, 'seconds').toISOString())
            .delete();
        // console.log(`Pruned ${deleteCount} reverseAddresses objects from storage`);
        return deleteCount;
    } catch (error) {
        console.log('Cannot prune reverseAddresses from storage', error);
    }
};

export const getReverseAddresses = async ({ latitude, longitude }) => {
    try {
        return await db.reverseAddresses.get({ latitude: latitude, longitude: longitude });
    } catch (error) {
        console.log('Cannot get reverseAddresses from storage', error);
    }
};

export const setReverseAddresses = async ({ latitude, longitude, data }) => {
    try {
        const id = await db.reverseAddresses.add({
            latitude: latitude,
            longitude: longitude,
            created_at: moment().toISOString(),
            data: data
        });
        return id;
    } catch (error) {
        console.log('Cannot add reverseAddresses in storage', error);
    }
};

export default { getReverseAddresses, pruneReverseAddresses };



// WEBPACK FOOTER //
// ./src/helpers/storageHelper.js